
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/user-info.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-user-info-demo-user-info","docs-power-design-user-info-demo-multiple"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/user-info.md?type=demo')
};